module.exports = __webpack_public_path__ + "img/briefcase.1b61fa05.svg";